export const api = {
    user: (): string => '/api/me/',
    userSecondFactorStatus: (): string => '/api/me/second-factor-status/',
    userAccountReferral: (userId: string): string => `/api/accounts/user/${userId}/referral/`,
    userMtan: (): string => '/accounts/user/mtan/',
    userPassword: (): string => '/accounts/user/password/',
    userState: (): string => '/api/accounts/user/state/'
};
